"use strict";

require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.symbol.to-primitive.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.date.to-primitive.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/web.dom-collections.iterator.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkWAFErrors = checkWAFErrors;
exports.getDetailedMessage = getDetailedMessage;
exports.loginFailure = loginFailure;
exports.loginRequest = loginRequest;
exports.loginSuccess = loginSuccess;
exports.logout = logout;
exports.send2FAResendActionRequest = send2FAResendActionRequest;
exports.send2FAResendRequest = send2FAResendRequest;
exports.send2FAVerifyActionRequest = send2FAVerifyActionRequest;
exports.send2FAVerifyRequest = send2FAVerifyRequest;
exports.sendAppleLoginRequest = sendAppleLoginRequest;
exports.sendFacebookLoginRequest = sendFacebookLoginRequest;
exports.sendLoginRequest = sendLoginRequest;
exports.sendResetPassword = sendResetPassword;
exports.sendSignOutRequest = sendSignOutRequest;
exports.sendSignupRequest = sendSignupRequest;
require("core-js/modules/es.error.cause.js");
require("core-js/modules/es.object.assign.js");
var ActionType = _interopRequireWildcard(require("./authActionTypes"));
var _api = _interopRequireDefault(require("../../http/api"));
var _googleTagManager = require("../../tracking/googleTagManager");
var _storage = require("../../util/storage");
var _statusCodes = _interopRequireDefault(require("../../http/statusCodes"));
var _detectBusinessUnit = _interopRequireDefault(require("../../util/detectBusinessUnit"));
var _userActions = require("../user/userActions");
var _experiments = require("../../experiments");
var _trackingHelper = require("../../tracking/trackingHelper");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// checks the reason from backend, and retuns a more specific error message
// or if reason doesn't exist, sends the message that comes from backend, or default error message

/**
 * An constant that stores error message and type in key value pair
 */
var ERROR_MESSAGE = {
  invalid_password: 'Your email and password do not match.',
  invalid_email: 'You have entered an invalid email.',
  user_locked: 'Looks like you have forgotten your password. Please click the forgot password link above to reset your password and continue.',
  'facebook-missing-email': 'You must provide Zola access to your Facebook email address to create your account.',
  default: 'There was a problem processing your request. Please try again or contact customer support for assistance.'
};

/**
 * Construct an error message base on error message types. If no match for the error type, return default.
 */
function getDetailedMessage(error) {
  var errorMessage = error && error.category && ERROR_MESSAGE[error.category.reason];
  return errorMessage || ERROR_MESSAGE.default;
}

/**
 * Construct an error message that contains the error response and user friendly message
 */
function createError(error) {
  var errorData = Object.assign({
    detailedMessage: getDetailedMessage(error === null || error === void 0 ? void 0 : error.response)
  }, error);
  throw errorData;
}

/**
 * Construct an error object if the status is a error, otherwise return the same response
 */
function checkWAFErrors(response) {
  if (response.status === _statusCodes.default.FORBIDDEN) {
    var error = new Error(response.statusText);
    error.response = response;
    error.detailedMessage = 'Please contact support@zola.com and we will assist you.';
    throw error;
  }
  if (response.status === _statusCodes.default.NOT_ACCEPTABLE) {
    var _error = new Error(response.statusText);
    _error.response = response;
    _error.detailedMessage = 'Your account has been locked due to too many failed login attempts. Please wait 1 hour and try again.';
    throw _error;
  }
  if (response.status === _statusCodes.default.TOO_MANY_REQUESTS) {
    var _error2 = new Error(response.statusText);
    _error2.response = response;
    _error2.detailedMessage = 'Please wait a few moments ...';
    throw _error2;
  }
}

/**
 * Action Creator: dispatch LOGIN_SUCCESS event
 */
function loginSuccess(email) {
  return {
    type: ActionType.LOGIN_SUCCESS,
    payload: {
      email: email
    }
  };
}

/**
 * Action Creator: dispatch LOGIN_FAILURE event
 */
function loginFailure(error) {
  var _error$response, _error$response2;
  return {
    type: ActionType.LOGIN_FAILURE,
    payload: {
      status: (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status,
      statusText: (_error$response2 = error.response) === null || _error$response2 === void 0 ? void 0 : _error$response2.statusText
    }
  };
}

/**
 * Action Creator: dispatch LOGIN_REQUEST event
 */
function loginRequest() {
  return {
    type: ActionType.LOGIN_REQUEST
  };
}

/**
 * Action Creator: dispatch LOGOUT event
 */
function logout() {
  return {
    type: ActionType.LOGOUT
  };
}

/**
 * Result of a succesful login.
 */

/**
 * Request body to login a couple using an email and password and optional invitation_session_id
 */

/**
 * Send login request to the server (web-nav) then notify GTM the user is logged in.
 *
 * @param loginFormRequest - Login Parameters
 * @returns A promise, when resolved, will have the user logged in.
 */
function sendLoginRequest(loginFormRequest) {
  return _api.default.post('/website-nav/web-api/v1/auth/login', loginFormRequest).then(function (data) {
    (0, _googleTagManager.setGTMLoggedIn)();
    (0, _experiments.clearExperimentStorage)();
    return data;
  }).then(function (data) {
    return (0, _userActions.identifyUserSailthru)(loginFormRequest.email).then(function () {
      return data;
    });
  }).catch(function (error) {
    checkWAFErrors(error);
    createError(error);
  });
}
/**
 * Send signup request to the server. Notify GTM the user is logged in
 */
function sendSignupRequest(createUserRequest) {
  var businessUnit = (0, _detectBusinessUnit.default)();
  var finalRequest = _objectSpread(_objectSpread({}, createUserRequest), {}, {
    business_unit_source: businessUnit
  });
  return _api.default.post('/website-nav/web-api/v1/user/create', finalRequest).then(function (data) {
    (0, _storage.setAllStorage)('zolaUserCreatedAt', new Date().toISOString());
    (0, _googleTagManager.setGTMLoggedIn)();
    var cookie = (0, _storage.getCookie)('pkey');
    if (cookie === '') cookie = null;
    (0, _trackingHelper.trackUserCreated)(createUserRequest.email, cookie);
    return data;
  }).then(function (data) {
    return (0, _userActions.identifyUserSailthru)(finalRequest.email).then(function () {
      return data;
    });
  }).catch(function (error) {
    return createError(error);
  });
}

/**
 * Send logout request to the server. Notify GTM the user is logged out
 */
function sendSignOutRequest() {
  return _api.default.get('/website-nav/web-api/v1/auth/signout').then(function () {
    (0, _googleTagManager.setGTMLoggedOut)();
  }).catch(function (error) {
    return createError(error);
  });
}

/**
 * Send reset password request to reset user password.
 *
 * @returns reset password callback
 */
function sendResetPassword(email) {
  var createResetPasswordRequest = {
    email: email,
    expires_in_num_days: 1,
    send_email: true,
    business_unit: (0, _detectBusinessUnit.default)()
  };
  return _api.default.post('/website-nav/web-api/v1/user/reset_password', createResetPasswordRequest);
}
function sendFacebookLoginRequest(fbLoginRequest) {
  return _api.default.post('/website-nav/web-api/v1/auth/facebook-login', fbLoginRequest);
}
function sendAppleLoginRequest(appleLoginRequest) {
  return _api.default.post('/website-nav/web-api/v1/auth/apple-login', appleLoginRequest);
}
function send2FAResendRequest(resendCodeRequest) {
  return _api.default.post('/website-nav/web-api/v1/twoFA/resend', resendCodeRequest);
}
function send2FAVerifyRequest(verifyRequest) {
  return _api.default.post('/website-nav/web-api/v1/twoFA/verify', verifyRequest).catch(function (error) {
    return createError(error);
  });
}
function send2FAVerifyActionRequest(verifyRequest) {
  return _api.default.post('/website-nav/web-api/v1/twoFA/action/verify', verifyRequest).catch(function (error) {
    return createError(error);
  });
}
function send2FAResendActionRequest() {
  return _api.default.post('/website-nav/web-api/v1/twoFA/action/resend');
}